import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {PathService} from "../../login/services/path.service";
import {Observable} from "rxjs";
import {PaginationArgs, PaginationPage} from "../models/pagination.args";
import {FeedbackWebDto} from "../models/feedback.web.dto";

@Injectable({
    providedIn: 'root'
})
export class FeedbackService {

    private baseUrl: string = '';

    constructor(protected http: HttpClient, private pathService: PathService) {
        this.baseUrl = `${pathService.hostServerBackOffice}/feedback`;
    }

    public findFeebacksByPage(paginationArgs: PaginationArgs): Observable<PaginationPage<FeedbackWebDto>> {
        return this.http.get<PaginationPage<FeedbackWebDto>>(`${this.baseUrl}?page=${paginationArgs.pageNumber}&size=${paginationArgs.pageSize}`);
    }

    public validateFeedBack(feedback: any): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}`, feedback);

    }
}
